module.exports = ReportHub;